import { render, staticRenderFns } from "./SingleOfferAll.vue?vue&type=template&id=8bcb2ade&scoped=true"
import script from "./SingleOfferAll.vue?vue&type=script&lang=js"
export * from "./SingleOfferAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcb2ade",
  null
  
)

export default component.exports